import { render, staticRenderFns } from "./DepartManagement.vue?vue&type=template&id=29eca062&scoped=true"
import script from "./DepartManagement.vue?vue&type=script&lang=ts"
export * from "./DepartManagement.vue?vue&type=script&lang=ts"
import style0 from "./DepartManagement.vue?vue&type=style&index=0&id=29eca062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29eca062",
  null
  
)

export default component.exports